import { render, staticRenderFns } from "./CardItemValue.vue?vue&type=template&id=4f040ac2"
import script from "./CardItemValue.vue?vue&type=script&lang=ts"
export * from "./CardItemValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f040ac2')) {
      api.createRecord('4f040ac2', component.options)
    } else {
      api.reload('4f040ac2', component.options)
    }
    module.hot.accept("./CardItemValue.vue?vue&type=template&id=4f040ac2", function () {
      api.rerender('4f040ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardItemValue.vue"
export default component.exports